import CodeEditor from './CodeEditor';
import './style/index.less';

export * from './CodeEditor';
export { default as DiffEditor } from './DiffEditor';

export * from './monaco-editor';
export * from './interface';
export default CodeEditor;
